import lazyWithRetry from '@shared/lib/lazyWithRetry';
import { Navigate } from 'react-router-dom';

import Loadable from '@components/Loadable/Loadable';

import SettingsPersonalInfoPage from '@pages/SettingsPage/PersonalInfo';
import SettingsChangePasswordPage from '@pages/SettingsPage/ChangePassword';
import SettingsSubscriptionPage from '@pages/SettingsPage/Subscription';
import SettingsBillingPage from '@pages/SettingsPage/Billing';
import SettingsUsersPage from '@pages/SettingsPage/Users';
import SettingsFirmProfilePage from '@pages/SettingsPage/FirmProfile';

const SettingsPage = Loadable(
  lazyWithRetry(() => import('@pages/SettingsPage'))
);

const SettingsChildRoutes = {
  path: 'settings',
  element: <SettingsPage />,
  children: [
    {
      path: '',
      element: <Navigate replace to="/settings/personal-info" />,
    },
    { path: 'personal-info', element: <SettingsPersonalInfoPage /> },
    { path: 'firm-profile', element: <SettingsFirmProfilePage /> },

    { path: 'password', element: <SettingsChangePasswordPage /> },
    { path: 'subscription', element: <SettingsSubscriptionPage /> },
    { path: 'billing', element: <SettingsBillingPage /> },
    { path: 'users', element: <SettingsUsersPage /> },
  ],
};

export default SettingsChildRoutes;
